import { createAsyncThunk } from "@reduxjs/toolkit";
import { customerPortal, toast } from "@vilocnv/allsetra-core";
import { isEmpty } from "lodash";
import { getGeozones } from "domain/geozones/api/get-geozones";

type GeozonesRequestDto = customerPortal.geozones.GetGeozonesRequestDto;

export const getGeozonesAction = createAsyncThunk(
  "geozones/getGeozonesAction",
  async ({ accountId }: GeozonesRequestDto) => {
    try {
      if (isEmpty(accountId)) {
        toast.error("Kindly first select an account from the drawer.");
        return;
      }

      return await getGeozones({ accountId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
